module.exports = __webpack_public_path__ + "img/8.d720d93a.jpg";